
export default {
  data() {
    return {}
  },
}
